import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { BolsaService } from '../../api/services';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';

@Component({
  selector: 'app-comprovativo-subsidio-modal',
  templateUrl: './comprovativo-subsidio-modal.component.html',
  imports: [ReactiveFormsModule, ButtonModule, InputTextModule, CalendarModule],
  styleUrls: ['./comprovativo-subsidio-modal.component.scss'],
})
export class ComprovativoSubsidioModalComponent {
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private bolsaService: BolsaService
  ) {
    this.form = this.fb.group({
      numeroMemorando: ['', Validators.required],
      numeroEstudantes: [0, Validators.required],
      valorSubsidio: ['', Validators.required],
      de: ['', Validators.required],
      ate: ['', Validators.required],
      dataEmissao: ['', Validators.required],
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.bolsaService
        .exportComprovativoSubsidio(this.form.value)
        .subscribe((response) => {
          const url = window.URL.createObjectURL(response);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'ComprovativoSubsidio.pdf';
          document.body.appendChild(a);
          a.click();
          this.ref.close();
        });
    } else {
      this.form.markAllAsTouched();
    }
  }

  onCancel() {
    this.ref.close();
  }
}
